/**
 * Public Entry Point for ApnaGuru Story Animation Engine (ASAE).
 * Exports core kernel, parsers, studio workbench, player, and router.
 */

import './studio/styles/studio.css';
import './player/styles/player.css';

// Core Engine Kernel
export * from './core/EventEmitter';
export * from './core/Easing';
export * from './core/Transform';
export * from './core/Interpolator';
export * from './core/Timeline';
export * from './core/Stage';
export * from './core/Camera';
export * from './core/Renderer';
export * from './core/AssetLoader';
export * from './core/Scene';
export * from './core/AnimationPlayer';
export * from './core/Engine';

// Schema & Parser
export * from './parser/Schema';
export * from './parser/Validation';
export * from './parser/JSONParser';
export * from './parser/JSONSerializer';
export * from './parser/AIStoryScript';

// Services & Auth
export * from './services/AuthService';
export * from './services/CourseApiService';

// Characters & Rigging
export * from './characters/CharacterRig';
export * from './characters/CharacterAnimator';
export * from './characters/LipSync';
export * from './characters/ExpressionController';
export * from './characters/CharacterPresets';
export * from './characters/Character';

// Objects & Multi-Content Support
export * from './objects/SVGObject';
export * from './objects/Shape';
export * from './objects/Text';
export * from './objects/Label';
export * from './objects/Arrow';
export * from './objects/Path';
export * from './objects/Bubble';
export * from './objects/Chalkboard';
export * from './objects/Compass';
export * from './objects/Ruler';
export * from './objects/Table';
export * from './objects/Flowchart';
export * from './objects/Image';
export * from './objects/Group';
export * from './objects/GeometryObject';

// Effects & SCORM Engine
export * from './effects/ParticleSystem';
export * from './effects/Fire';
export * from './effects/Rain';
export * from './effects/Sparkles';
export * from './effects/Confetti';
export * from './scorm/ScormPlayer';

// Audio & Speech
export * from './audio/AudioManager';
export * from './audio/VoicePlayer';
export * from './audio/Subtitle';
export * from './audio/Narration';
export * from './audio/BackgroundMusic';

// Interactions & Assessment
export * from './interaction/Quiz';
export * from './interaction/Pointer';

// Dual Modes, Router & Views
export * from './samples/SampleRegistry';
export * from './dashboard/DashboardView';
export * from './generator/CourseGeneratorView';
export * from './studio/StudioApp';
export * from './student/LearningView';
export * from './router/AppRouter';

// Bootstrap SPA with Path Router
import { AppRouter } from './router/AppRouter';

if (typeof document !== 'undefined') {
  const initApp = () => {
    const root = document.getElementById('app');
    if (root && !(window as any).__ASAE_ROUTER_INITIALIZED__) {
      (window as any).__ASAE_ROUTER_INITIALIZED__ = true;
      const router = new AppRouter(root);
      (window as any).appRouter = router;
      router.handleRoute();
    }
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }
}
